import React, { useState, useContext } from 'react'
import ContextDetails from '../Context/ContextDetails';
import { toast } from "react-toastify";

function Reply({ data, auth, addReplies, addLike }) {
    let validUser = auth === null ? false : true;
    let likeDetails = useContext(ContextDetails);
    const [name, setName] = useState(auth ? auth.name : "");
    const [email, setEmail] = useState(auth ? auth.email : "");
    const [comment, setComment] = useState("");
    const [replyOpen, setReplyOpen] = useState(false);
    const [likeOpen, setLikeOpen] = useState(false);
    const [liked, setLiked] = useState(false);
    const likedFeedback = () => {
        if (validUser) {

            setLikeOpen(false);
            setLiked(true);
            addLike(data.feedBackId, email);
        } else {
            if (name.trim() === "") {
                toast('Please put name!', {
                    type: "error",
                });
            } else if (email.trim() === "") {
                toast('Please put email!', {
                    type: "error",
                });
            } else {
                setLikeOpen(false);
                setLiked(true);
                addLike(data.feedBackId, email);
            }
        }
    }

    const replySubmitted = () => {
        if (validUser) {
            if (comment.trim() === "") {
                toast('Please put message!', {
                    type: "error",
                });
            } else {
                setReplyOpen(false);
                addReplies(data.feedBackId, { name, email, comment });
            }
        } else {
            if (name.trim() === "") {
                toast('Please put name!', {
                    type: "error",
                });
            } else if (email.trim() === "") {
                toast('Please put email!', {
                    type: "error",
                });
            } else {
                setReplyOpen(false);
                addReplies(data.feedBackId, { name, email, comment })
            }
        }
    }
    return (
        <div className="media feedback">
            <a className="pull-left" href="#"><img className="media-object" src="https://bootdey.com/img/Content/avatar/avatar2.png" alt=""></img></a>
            <div className="media-body">
                <h4 className="media-heading">{data.name}</h4>
                <p>{data.comment}</p>
                {
                    /* 
                        <div className="feedback-action">
                            <ul className="list-unstyled list-inline media-detail pull-left">
                                <li style={{ "marginRight": "40px" }}><i className="fa fa-calendar"></i>{data.uploadedDate}</li>
                                <li><i className="fa fa-thumbs-up"></i>{data.likes?data.likes.length:0}</li>
                            </ul>
                            <ul className="list-unstyled list-inline media-detail pull-right">
                                {liked ? "" : <li className="custom-link" style={{ "marginRight": "40px" }} onClick={() => validUser ? likedFeedback() : setLikeOpen(!likeOpen)}>Like</li>}
                                <li className="custom-link" onClick={() => setReplyOpen(!replyOpen)}>Reply</li>
                            </ul>
                        </div>
                    */
                }
                
                <div className="feedback-action">
                    <ul className="list-unstyled list-inline media-detail pull-left">
                        <li style={{ "marginRight": "40px" }}><i className="fa fa-calendar"></i>{data.uploadedDate}</li>
                    </ul>
                </div>
                <div className={replyOpen ? "collapse show" : "collapse"}>
                    <div className="card card-body">
                        <div className="row">
                            <div className="col-lg-12 mt-5 mt-lg-0">
                                {
                                    validUser ? "" : <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Name<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} className="form-control" id="name" />
                                            <div className="validate"></div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Email<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} name="email" id="email" />
                                            <div className="validate"></div>
                                        </div>
                                    </div>
                                }
                                <div className="form-group">
                                    <label htmlFor="name">Comments<sup style={{ "color": "red" }}>*</sup></label>
                                    <textarea className="form-control" name="message" value={comment} onChange={(e) => setComment(e.target.value)} rows="4"></textarea>
                                    <div className="validate"></div>
                                </div>
                                <div className="text-center"><button type="button" className="btn btn-primary" onClick={replySubmitted}>Reply</button></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={likeOpen ? "collapse show" : "collapse"} >
                    <div className="card card-body">
                        <div className="row">
                            <div className="col-lg-12 mt-5 mt-lg-0">
                                {
                                    validUser ? "" : <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Name<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} className="form-control" id="name" />
                                            <div className="validate"></div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Email<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} name="email" id="email" />
                                            <div className="validate"></div>
                                        </div>
                                    </div>
                                }
                                <div className="text-center"><button type="button" className="btn btn-primary" onClick={likedFeedback}>Like</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reply
